export default __webpack_public_path__ + "static/media/icon-password.2a037657.svg";